import VueRouter, { RouteConfig } from 'vue-router';
import { LAST_REDIRECTED_ROUTE_KEY, navigationGuard } from '@/utils/navigation-guard';
import RouteWrapper from '@/views/common/RouteWrapper.vue';
import { pageViewTracker } from '@/utils/mixins/analytics';
import { ProfileRoutes, OnboardingRoutes } from '../views/dashboard/profile/routes';
import PreloginRoutes from '../views/prelogin/routes';
import ManagementRoutes from '../views/dashboard/management/routes';
import DashboardRoutes from '../views/dashboard/dashboard/routes';
import DeploymentRoutes from '../views/dashboard/deployments/routes';
import AdminRoutes from '../views/admin/routes';
import ServerCreateRoutes from '../views/dashboard/server-create/routes';

const SettingsFlatRoutes: RouteConfig[] = [
  {
    path: 'account',
    name: 'accountSettings',
    meta: { hideNavbar: true },
    component: () => import(/* webpackChunkName: "profile" */ '@/views/dashboard/profile/AccountSettings.vue'),
  },
  {
    path: 'workspace',
    name: 'workspaceSettings',
    meta: { hideNavbar: true },
    component: () => import(/* webpackChunkName: "management" */ '@/views/dashboard/management/Company.vue'),
  },
  {
    path: 'team',
    name: 'teamSettings',
    meta: { hideNavbar: true },
    component: () => import(/* webpackChunkName: "management" */ '@/views/dashboard/management/Team.vue'),
  },
  {
    path: 'billing',
    name: 'billingSettings',
    meta: { hideNavbar: true },
    component: () => import(/* webpackChunkName: "management" */ '@/views/dashboard/management/PaymentMethods.vue'),
  },
];

const routes: Array<RouteConfig> = [
  {
    path: '/c/:cid/p/:pid',
    component: RouteWrapper,
    children: [
      ...SettingsFlatRoutes,
      ...ProfileRoutes,
      ...ManagementRoutes,
      ...DashboardRoutes,
      ...DeploymentRoutes,
      ...ServerCreateRoutes,
    ],
  },
  ...AdminRoutes,
  ...OnboardingRoutes,
  ...PreloginRoutes,
  {
    name: 'Redirect',
    meta: { hideNavbar: true },
    path: '/redirect',
    component: () => import(/* webpackChunkName: "common" */ '../views/common/Redirect.vue'),
  },
  {
    name: 'Loading',
    path: '/loading',
    component: () => import(/* webpackChunkName: "common" */ '../views/common/Loading.vue'),
  },
  {
    path: ':*',
    component: () => import(/* webpackChunkName: "common" */ '../views/common/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

export function getLastRedirected() {
  const lastRed = localStorage.getItem(LAST_REDIRECTED_ROUTE_KEY);
  if (lastRed) {
    localStorage.removeItem(LAST_REDIRECTED_ROUTE_KEY);
    return lastRed;
  }
  return null;
}

router.beforeEach(navigationGuard);
router.beforeResolve(pageViewTracker);

router.afterEach((to, from) => {
  const base = 'Countly Flex';
  const metaTitle = (to.meta && to.meta.title) ? to.meta.title : base;
  document.title = metaTitle;
});

export default router;
